function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var AdjustStakeTemplate = require('./adjust-stake.template');
var AdjustStake = /*#__PURE__*/function () {
  function AdjustStake(app, mod) {
    _classCallCheck(this, AdjustStake);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
  }
  return _createClass(AdjustStake, [{
    key: "bindSelectOnZeroFocus",
    value: function bindSelectOnZeroFocus(input) {
      if (!input) {
        return;
      }
      var selectIfZero = function selectIfZero() {
        if (parseFloat(input.value) === 0) {
          input.select();
        }
      };
      input.addEventListener('focus', selectIfZero);
      input.addEventListener('click', selectIfZero);
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        var _obj$game_mod;
        var current_balance, i, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (obj !== null && obj !== void 0 && obj.accept_callback) {
                this.accept_callback = obj.accept_callback;
              }
              if (obj !== null && obj !== void 0 && obj.reject_callback) {
                this.reject_callback = obj.reject_callback;
              }
              this.min_stake = parseFloat(obj.stake.min);
              this.match_stake = this.min_stake;
              _t = Number;
              _context.n = 1;
              return this.app.wallet.returnPreferredCryptoBalance();
            case 1:
              current_balance = _t(_context.v);
              this.max_stake = current_balance;
              for (i in obj.stake) {
                if (parseFloat(obj.stake[i]) > this.match_stake) {
                  this.match_stake = parseFloat(obj.stake[i]);
                }
              }
              if ((_obj$game_mod = obj.game_mod) !== null && _obj$game_mod !== void 0 && _obj$game_mod.opengame) {
                this.max_stake = Math.min(current_balance, this.match_stake);
              }
              this.ticker = obj.ticker;
              this.overlay.show(AdjustStakeTemplate(this.app, this), this.reject_callback);
              this.overlay.blockClose('#enable_staking_yes');
              this.attachEvents();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var stake_input = document.getElementById('amount_to_stake_input');
      if (!stake_input) {
        return;
      }
      this.bindSelectOnZeroFocus(stake_input);
      var match_button = document.querySelector('.select_match');
      if (match_button && !match_button.classList.contains('nomatch')) {
        match_button.onclick = function (e) {
          stake_input.value = _this.match_stake;
        };
      }
      var min_button = document.querySelector('.select_min');
      if (min_button) {
        min_button.onclick = function (e) {
          stake_input.value = _this.min_stake;
        };
      }
      var max_button = document.querySelector('.select_max');
      if (max_button) {
        max_button.onclick = function (e) {
          stake_input.value = _this.max_stake;
        };
      }
      stake_input.onkeydown = function (e) {
        _this.app.browser.validateAmountLimit(stake_input.value, e);
      };
      stake_input.oninput = function (e) {
        _this.validateAmount();
      };
      document.querySelector('#enable_staking_yes').onclick = function (e) {
        if (!_this.validateAmount()) {
          return;
        }
        if (_this.accept_callback) {
          _this.accept_callback(parseFloat(stake_input.value));
        }
        _this.overlay.close();
      };
      document.querySelector('#enable_staking_no').onclick = function (e) {
        if (_this.reject_callback) {
          _this.reject_callback();
        }
        _this.overlay.close();
      };
    }
  }, {
    key: "validateAmount",
    value: function validateAmount() {
      var amount = document.getElementById('amount_to_stake_input').value;
      var input_err = document.querySelector('#stake-amount-error');
      var errorMsg = '';
      amount = parseFloat(amount);
      input_err.innerText = '';
      input_err.style.display = 'none';
      if (amount < 0) {
        errorMsg = 'You need to select a non-negative value';
      } else if (amount > this.max_stake) {
        errorMsg = "You don't have that much to stake";
      } else if (amount < this.min_stake) {
        errorMsg = "You need to stake at least ".concat(this.min_stake);
      }
      if (errorMsg) {
        input_err.innerText = errorMsg;
        input_err.style.display = 'block';
        this.mod.validateBalance(amount, this.ticker);
        return false;
      }
      return true;
    }
  }]);
}();
module.exports = AdjustStake;